<template>
    <div class="recuperar-email">
        <div class="container">
            <v-snackbar v-model="loginSuccess" color="success" top :timeout="8000">
                <span>Alteração efetuada com sucesso! Verifique seu e-mail e siga as instruções para redefinir sua senha. Verificar sua caixa de Spam.</span>
                <v-btn color="info" @click="loginSuccess=false">Ok</v-btn>
            </v-snackbar>

            <v-snackbar color="error" v-model="loginFail" top :timeout="8000">
                <span>Não foi possível efetuar a operação! Verifique os campos informados e tente novamente.</span>
                <v-btn color="info" @click="loginFail=false">Fechar</v-btn>
            </v-snackbar>

            <h1 class="display-1 primary--text my-3">Recuperar E-mail</h1>
            <v-divider></v-divider>
            <v-row wrap justify="center">
                <v-flex xs12 sm6 lg4>
                    <v-card hover class="ma-4">
                        <v-card-title>Atualização de E-mail</v-card-title>
                        <v-card-text>
                            <span class="body-2">Informe os dados abaixo para atualização de e-mail de cadastro.</span>

                            <v-form ref="form" class="my-3">
                                <v-text-field
                                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                                        clearable
                                        v-model="cpfCnpj"
                                        :rules="regrasObrigacao"
                                        label="CPF/CNPJ"
                                        required
                                        prepend-icon="account_circle"
                                ></v-text-field>

                                <v-text-field
                                        v-mask="['######']"
                                        clearable
                                        v-model="im"
                                        :rules="regrasObrigacao"
                                        label="Inscrição Municipal"
                                        required
                                        prepend-icon="assignment"
                                ></v-text-field>

                                <v-text-field
                                        v-mask="['###.###.###-##']"
                                        clearable
                                        v-model="solicitante"
                                        :rules="regrasObrigacao"
                                        label="CPF Solicitante"
                                        required
                                        prepend-icon="account_box"
                                ></v-text-field>

                                <v-text-field
                                        v-model="email"
                                        clearable
                                        :rules="regraEmail"
                                        label="Novo E-mail"
                                        required
                                        prepend-icon="email"
                                ></v-text-field>
                                <v-checkbox
                                        v-model="checkbox"
                                        :rules="[v => !!v || 'Você deve concordar para continuar!']"
                                        label="Confirmo a veracidade das informações prestadas."
                                        required
                                ></v-checkbox>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                    color="info"
                                    outlined
                                    small
                                    type="submit"
                                    :href="getBaseUrl"
                            >
                                <v-icon small left>check_circle</v-icon>
                                <span>Cadastro</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn small color="primary" type="submit" @click="recuperarEmail">
                                <v-icon small left>check_circle</v-icon>
                                <span>Recuperar E-mail</span>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mask} from "vue-the-mask";
import {base_url} from "../global";
import {httpNF} from "../axios.config";

export default {
        directives: {mask},
        data() {
            return {
                cpfCnpj: null,
                im: null,
                solicitante: null,
                email: null,
                checkbox: false,
                loginSuccess: false,
                loginFail: false,
                regrasObrigacao: [V => !!V || "Campo obrigatório!"],
                regraEmail: [
                    v => !!v || "Campo oborigatório!",
                    v => /.+@.+\..+/.test(v) || "Informe um e-mail válido"
                ]
            };
        },
        methods: {
            recuperarEmail() {
                axios.defaults.baseURL = `${httpNF}/acesso/atualizaemail`;

                // console.log(axios.defaults.baseURL);

                if (!this.$refs.form.validate()) {
                    // console.log('erro!');
                } else {
                    this.cpfCnpj = this.removeMask(this.cpfCnpj);
                    this.solicitante = this.removeMask(this.solicitante);
                    axios
                        .put(
                            `/cpfCnpj/${this.cpfCnpj}/im/${this.im}/cpfCnpjSolicitante/${this.solicitante}/email/${this.email}/sistema/NOTAFISCAL_EXTERNO`
                        )
                        .then(() => {
                            this.loginSuccess = true;
                        })
                        // .catch(error => {
                        //     this.loginFail = false;
                            // console.log(error);
                        // });
                }
            },
            removeMask(mask) {
                return mask.replace(/[^a-zA-Z0-9]/g, "");
            }
        },
        computed: {
            getBaseUrl() {
                return `${base_url}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?mostraCampoMatricula=N&faces-redirect=true`
            }
        }

    };
</script>

<style scoped>
</style>
